import { Injectable } from '@angular/core';
import { Observable, retry, shareReplay, switchMap, timeout } from 'rxjs';
import { TenantRepository } from '@repository/tenant/tenant.repository';
import { EnvironmentService } from '@services/environment.service';
import { TenantSSOOptions } from '../types/login/SSO';

@Injectable({ providedIn: 'root' })
export class TenantSSOOptionsService {
  private static readonly TIMEOUT_MS = 5000;

  public readonly tenantSSOOptions$: Observable<TenantSSOOptions>;

  public constructor(environmentService: EnvironmentService, tenantRepository: TenantRepository) {
    this.tenantSSOOptions$ = environmentService.init().pipe(
      switchMap(() => tenantRepository.getTenantSSOOptions()),
      timeout(TenantSSOOptionsService.TIMEOUT_MS),
      retry({ count: 5, delay: 2000 }),
      shareReplay({ bufferSize: 1, refCount: false }),
    );
  }
}
